'use client';
import React, { ReactNode } from 'react';

import { AccordionProvider } from '@/components/molecules/accordion/AccordionProvider';

interface AccordionProps {
  children: ReactNode;
}

export function Accordion({ children }: AccordionProps) {
  console.log('Accordion Rendered');

  return <AccordionProvider>{children}</AccordionProvider>;
}
